
import * as ipxRuntime$RaU6apoDy_cJZqXlmiu_45wjtZ6FmTY_45yf_45oeDo1hwgIw from '/var/www/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 376,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1366,
    "4xl": 1920,
    "3xl": 1536,
    "2xs": 360
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$RaU6apoDy_cJZqXlmiu_45wjtZ6FmTY_45yf_45oeDo1hwgIw, defaults: {} }
}
        